import { render, staticRenderFns } from "./innerIntegrations.vue?vue&type=template&id=0220d936&scoped=true"
import script from "./innerIntegrations.vue?vue&type=script&lang=js"
export * from "./innerIntegrations.vue?vue&type=script&lang=js"
import style0 from "./innerIntegrations.vue?vue&type=style&index=0&id=0220d936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220d936",
  null
  
)

export default component.exports